module.exports = __webpack_public_path__ + "img/icon-lowthc.9eb10dc7.svg";